(function(window, questionViewFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.QuestionView = questionViewFactory(namespace.templates, namespace.localizationStrings, namespace.log, namespace.AnswersView);
})(this, function(templates, localizationStrings, log, AnswersView) {
   'use strict';

   var QUESTION_CORRECT_TEXT_CLASS = '.question-correct-text';
   var QUESTION_INCORRECT_TEXT_CLASS = '.question-incorrect-text';

   /**
    * @memberof TSC
    * @class QuestionView
    * @classdesc Question View
    * @params {Object} $questionTextContainer - jquery wrapper for question text container element
    * @params {Object} $feedbackContainer - jquery wrapper for feedback text container element
    * @params {Object} $answersContainer - jquery wrapper for answers container element
    * @params {TSC.Question} question - Question model for this view.
    * @params {Boolean} showResults - show results for question.
    */
   var QuestionView = function($questionTextContainer, $feedbackContainer, $answersContainer, question, showResults) {
      var _questionTextTemplate = null;
      var _answersView;

      if (templates && templates.question_text_template) {
         _questionTextTemplate = templates.question_text_template;
      } else {
         log.logException('Question View: Question Text Template not found.');
      }

      var createView = function() {
         _answersView = AnswersView.create($answersContainer, question, showResults);
         $feedbackContainer.addClass('hide-element');
         var correctAnswerText = showResults && question.isGraded ? _answersView.getCorrectAnswerText() : '';

         var questionTextContext = {
            questionText: question.text,
            correctTextString: localizationStrings.strings.txtCorrectString,
            incorrectTextString: localizationStrings.strings.txtIncorrectString,
            correctAnswerText: correctAnswerText
         };
         var questionTextMarkup = _questionTextTemplate(questionTextContext);
         $questionTextContainer.html(questionTextMarkup);
      };

      var showFeedbackTextIfAvailable = function() {
         var feedbackMarkup = null;

         question.feedback.forEach(function(feedback) {
            if (question.isResponseCorrect && feedback.reason === 'correct') {
               feedbackMarkup = feedback.markupText;
            } else if (!question.isResponseCorrect && feedback.reason === 'incorrect') {
               feedbackMarkup = feedback.markupText;
            }
         });

         if (feedbackMarkup) {
            $feedbackContainer.html(feedbackMarkup);
            $feedbackContainer.removeClass('hide-element');
         }
      };

      var setupView = function() {
         if (showResults && question.isGraded) {
            showFeedbackTextIfAvailable();
            if (question.isResponseCorrect) {
               $questionTextContainer.find(QUESTION_CORRECT_TEXT_CLASS).removeClass('hide-element');
            } else {
               $questionTextContainer.find(QUESTION_INCORRECT_TEXT_CLASS).removeClass('hide-element');
            }
         }
      };

      createView();
      setupView();

      return {
         destroy: _answersView.destroy,
         getUserResponse: _answersView.getUserResponse
      };
   };

   return {
      /**
       *  Factory method that returns a new QuestionView object.
       *  @function create
       *  @memberof TSC.QuestionView
       *  @static
       *  @return new QuestionView instance
       */
      create: QuestionView
   };
});
